import Layout from "./components/layout/Layout_final";
import { useEffect } from "react";
import UpdatePassword from "./pages/login/UpdatePassword";
import { getOneData, postData } from "./components/helpers/Data";
import ReactDOM from "react-dom";
import UpdateEmail from "./pages/login/UpdateEmail";
import { userGroups } from "./components/helpers/UserGroups";
import LayoutMobile from "./components/layout/LayoutMobile";
import "./css/FormElements.css";
import "./css/Table.css";
import SalesMain from "./pages/sales_main";
import AddStock from "./pages/admin/AddItems/AddStock";
import Reports from "./pages/Reports";
import Items from "./pages/Items";

const App = () => {
  let module = [];
  //on all app initialization
  useEffect(() => {
    let sessionId = sessionStorage.getItem("mwerezi_mpos_sessionId");
    if (!sessionId) {
      sessionId = Date.now() + "_" + Math.random().toString(36).substr(2, 9);
      sessionStorage.setItem("mwerezi_mpos_sessionId", sessionId);
    }

    // 2️⃣ Clear reservations on refresh/tab close
    window.addEventListener("beforeunload", async () => {
      const sessionId = sessionStorage.getItem("mwerezi_mpos_sessionId");
      if (!sessionId) return;
      const frmData = new FormData();
      frmData.append("session_id", sessionId);

      postData(frmData, "clear_reservations")
        .then((data) => {
          console.log(data);
        })
        .catch((error) => {
          console.log(error);
        });
    });
    //check if password has expired
    const frmData = new FormData();
    frmData.append("username", sessionStorage.getItem("mwerezi_mpos_username"));
    frmData.append("fullname", localStorage.getItem("mpos_fullname"));
    postData(frmData, "check_last_password_change")
      .then((data) => {
        if (data[0] >= 30) {
          ReactDOM.render(<UpdatePassword />, document.getElementById("root"));
        }
      })
      .catch((error) => {
        console.log(error);
      });

    //check if email exists
    getOneData(
      "check_email_exists",
      sessionStorage.getItem("mwerezi_mpos_username"),
    )
      .then((data) => {
        console.log(data);
        if (data.length == 0) {
          ReactDOM.render(<UpdateEmail />, document.getElementById("root"));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  if (userGroups().includes(1) || userGroups().includes(2)) {
    //admin or developer
    module = <Layout />;
  } else if (userGroups().includes(3)) {
    //sales
    module = <SalesMain />;
  } else if (userGroups().includes(4)) {
    //management
    module = <Reports />;
  } else if (userGroups().includes(5)) {
    //procurement
    module = <AddStock />;
  } else if (userGroups().includes(6)) {
    //procurement manager
    module = <Items />;
  }

  return module;

  // if (window.innerWidth <= 768) {
  //   return (
  //     <div>
  //       <LayoutMobile />
  //     </div>
  //   );
  // } else {
  //   return (
  //     <div>
  //       <Layout />
  //     </div>
  //   );
  // }
};

export default App;
